import React, { useId } from "react";

function Input({ label, type = "text", ...props }, ref) {
  const id = useId();
  return (
    <>
      {label && (
        <label
          htmlFor={id}
          className="block mb-2 text-sm font-medium text-white"
        >
          {label}
        </label>
      )}
      <input
        type={type}
        className="bg-gray-50 border sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500"
        id={id}
        {...props}
        ref={ref}
      />
    </>
  );
}

export default React.forwardRef(Input);
